import {
	ITEM_FETCH,
	ITEM_CREATE,
	ITEM_UPDATE,
	ITEM_DELETE,
} from "../actions/actionTypes";

const initialState = [];

function itemReducer(state = initialState, action) {
	switch (action.type) {
		case ITEM_FETCH:
			return action.payload.allItem;
		case ITEM_CREATE:
			return action.payload.newItemArray;
		case ITEM_UPDATE:
			return action.payload.newItemArray;
		case ITEM_DELETE:
			return action.payload.newItemArray;
		default:
			return state;
	}
}

export default itemReducer;
